// src/components/SEOManager.jsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { seoConfig } from '../seoConfig';

const SEOManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = seoConfig[pathname];

    if (!seo) return; // Admin/User routes pe kuch mat karo

    // Title
    document.title = seo.title;

    // Helper function
    const setMeta = (name, content, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // Standard Meta
    setMeta('description', seo.description);
    if (seo.keywords) setMeta('keywords', seo.keywords);

    // Open Graph
    setMeta('og:title', seo.title, true);
    setMeta('og:description', seo.description, true);
    setMeta('og:url', window.location.href, true);
    setMeta('og:type', 'website', true);

    // Twitter
    setMeta('twitter:title', seo.title);
    setMeta('twitter:description', seo.description);
    setMeta('twitter:card', 'summary_large_image');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.href);

  }, [pathname]);

  return null; // Koi UI render nahi hoga
};

export default SEOManager;